export default __webpack_public_path__ + "static/media/EG_ReSynth-4.9f72a64a.wav";